














































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {DiagramSettings} from '@/interfaces/diagrams';
import {DiagramType} from '@/enums/diagrams';
import SimpleDialog from '@c/SimpleDialog.vue';
import {spectrumYAxisTypes} from '@/api/configurate';

@Component({
  components: {SimpleDialog},
})
export default class DiagramSettingsDialog extends Vue {
  dialog = false;

  get spectrumYAxisTypes() {
    return spectrumYAxisTypes;
  }

  @Watch('dialog')
  onDialog(value: boolean) {
    if (!value) this.updateSelectBtnState();
  }

  selectSettingsBtnIndex: number | null = null;

  @Prop({required: false, default: false})
  disabled!: boolean;

  @Prop({required: true})
  settings!: DiagramSettings;

  @Prop({required: false, type: Array, default: () => []})
  freqbands!: any[];

  dialogSettings: DiagramSettings = {...this.settings};

  matchColor = this.settings.matchColor;

  menuPalette = false;

  @Watch('settings')
  setDialogSettings(settings: DiagramSettings) {
    this.dialogSettings = {...settings};
  }

  isSpectrum(type: DiagramType) {
    return type === DiagramType.Spectrum;
  }

  onClickCancelSelect() {
    this.dialog = false;
    this.dialogSettings = {...this.settings};
  }

  onApplySettings() {
    this.dialog = false;
    this.updateSelectBtnState();
    this.$emit('select', this.dialogSettings);
  }

  btnActiveState = false;
  updateSelectBtnState() {
    this.btnActiveState = this.dialog;
    this.selectSettingsBtnIndex = this.dialog ? 0 : null;
  }

  setNewColor() {
    this.dialogSettings.matchColor = this.matchColor;
    this.menuPalette = false;
  }

  resetColor() {
    this.matchColor = this.dialogSettings.matchColor;
    this.menuPalette = false;
  }
}
